import createReducer from 'app/redux/utils/create-reducer';

import { initialState, Types } from './actions';

const actionHandlers = {
  [Types.GLOBAL_VIEWPORT_CHANGED]: (state, action) => ({
    ...state,
    viewport: action.viewport,
  }),
};

export default createReducer(initialState, actionHandlers);



// WEBPACK FOOTER //
// ./src/redux/globals/reducer.js